// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminProduct = (client) => ({
    /**
     * `POST /admin/products/:productId/code-nodes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/[productId]/code-nodes/route.ts
     */
    createCodeNode: (productId, body, query, headers) => client.fetch(buildPath("/admin/products/:productId/code-nodes", [productId]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/products/variants/:variantId/codes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/variants/[variantId]/codes/route.ts
     */
    createVariantsCode: (variantId, body, query, headers) => client.fetch(buildPath("/admin/products/variants/:variantId/codes", [variantId]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/[productId]/code-nodes/[id]/route.ts
     */
    deleteCodeNode: (productId, id, body, query, headers) => client.fetch(buildPath("/admin/products/:productId/code-nodes/:id", [productId, id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /admin/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/variants/[variantId]/codes/[id]/route.ts
     */
    deleteVariantsCode: (variantId, id, body, query, headers) => client.fetch(buildPath("/admin/products/variants/:variantId/codes/:id", [variantId, id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/products/:id/applicable-attributes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductApplicableAttributes
     * @source packages/modules/b2c-core/src/api/admin/products/[id]/applicable-attributes/route.ts
     */
    listApplicableAttributes: (id, query, headers) => client.fetch(buildPath("/admin/products/:id/applicable-attributes", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/products/:productId/code-nodes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListProductCodeNodes
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/[productId]/code-nodes/route.ts
     */
    listCodeNodes: (productId, query, headers) => client.fetch(buildPath("/admin/products/:productId/code-nodes", [productId]), { method: "GET", query, headers }),
    /**
     * `GET /admin/products/:id/sellers`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListProductSellers
     * @source packages/modules/b2c-core/src/api/admin/products/[id]/sellers/route.ts
     */
    listSellers: (id, query, headers) => client.fetch(buildPath("/admin/products/:id/sellers", [id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/products/variants/:variantId/codes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListProductCodes
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/variants/[variantId]/codes/route.ts
     */
    listVariantsCodes: (variantId, query, headers) => client.fetch(buildPath("/admin/products/variants/:variantId/codes", [variantId]), { method: "GET", query, headers }),
    /**
     * `GET /admin/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/[productId]/code-nodes/[id]/route.ts
     */
    retrieveCodeNode: (productId, id, query, headers) => client.fetch(buildPath("/admin/products/:productId/code-nodes/:id", [productId, id]), { method: "GET", query, headers }),
    /**
     * `GET /admin/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/variants/[variantId]/codes/[id]/route.ts
     */
    retrieveVariantsCode: (variantId, id, query, headers) => client.fetch(buildPath("/admin/products/variants/:variantId/codes/:id", [variantId, id]), { method: "GET", query, headers }),
    /**
     * `PUT /admin/products/:productId/code-nodes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateProductCodeNode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/[productId]/code-nodes/[id]/route.ts
     */
    updateCodeNode: (productId, id, body, query, headers) => client.fetch(buildPath("/admin/products/:productId/code-nodes/:id", [productId, id]), { method: "PUT", body, query, headers }),
    /**
     * `PUT /admin/products/variants/:variantId/codes/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateProductCode
     * @source packages/medusa-plugin-product-codes-v2/src/api/admin/products/variants/[variantId]/codes/[id]/route.ts
     */
    updateVariantsCode: (variantId, id, body, query, headers) => client.fetch(buildPath("/admin/products/variants/:variantId/codes/:id", [variantId, id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=products.js.map